import { differenceInDays, formatISO, parseISO } from "date-fns";
import { useState } from "react";

const getInstallPromptLastSeenAt = (promptName: string): string | null => {
  if (typeof window !== "undefined") return localStorage.getItem(promptName);
  return null;
};

const setInstallPromptSeenToday = (promptName: string): void => {
  const today = formatISO(new Date(), { representation: "complete" });
  localStorage.setItem(promptName, today);
};

function getUserShouldBePromptedToInstall(
  promptName: string,
  daysToWaitBeforePromptingAgain: number
): boolean {
  const lastPrompt = parseISO(getInstallPromptLastSeenAt(promptName) || "");

  const daysSinceLastPrompt = differenceInDays(new Date(), lastPrompt);
  return isNaN(daysSinceLastPrompt) || daysSinceLastPrompt > daysToWaitBeforePromptingAgain;
}

const useShouldShowPrompt = (
  promptName: string,
  daysToWaitBeforePromptingAgain = 180
): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, setUserShouldBePromptedToInstall] = useState(
    getUserShouldBePromptedToInstall(promptName, daysToWaitBeforePromptingAgain)
  );

  const handleUserSeeingInstallPrompt = () => {
    setUserShouldBePromptedToInstall(false);
    setInstallPromptSeenToday(promptName);
  };
  return [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt];
};

export default useShouldShowPrompt;
